'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = MenuOption;

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _style = require('./style.css');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function checkmark(qualityChangeLoading, loadingStateCheck) {
  if (loadingStateCheck) {
    var loading = loadingStateCheck(qualityChangeLoading);
    if (loading) {
      return loading;
    }
  }

  return _react2.default.createElement(
    'div',
    { className: _style.actionOptionCheck },
    _react2.default.createElement(
      'svg',
      { width: '11', height: '8' },
      _react2.default.createElement('path', { d: 'M4 5L1.8 2.6.6 4l2.2 2v.2L4 7.4l1.3-1.2 5-5L8.8 0 4 5z' })
    )
  );
} /* eslint-disable react/no-multi-comp */
/**
 * Copyright 2013-2015, Hudl
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule MenuOption
 */

function MenuOption(_ref) {
  var active = _ref.active,
      onClick = _ref.onClick,
      label = _ref.label,
      loadingStateCheck = _ref.loadingStateCheck,
      qualityChangeLoading = _ref.qualityChangeLoading;

  var className = _style.menuOption;

  if (active) {
    className += ' ' + _style.activeOption;
  }

  return _react2.default.createElement(
    'li',
    { className: className, onClick: onClick },
    _react2.default.createElement(
      'div',
      null,
      active && checkmark(qualityChangeLoading, loadingStateCheck),
      _react2.default.createElement(
        'span',
        null,
        label
      )
    )
  );
}

MenuOption.propTypes = {
  active: _propTypes2.default.bool.isRequired,
  onClick: _propTypes2.default.func.isRequired,
  label: _propTypes2.default.string.isRequired,
  loadingStateCheck: _propTypes2.default.func,
  qualityChangeLoading: _propTypes2.default.bool
};

MenuOption.displayName = 'MenuOption';
module.exports = exports['default'];